export default {
  path: '/locations',
  name: 'locations',
  component: () => import(/* webpackChunkName: "locations" */ './_views/UmsLocations.vue'),
  meta: {
    title: 'Locations',
    navigation: {
      position: 3,
      name: 'Locations',
      icon: 'room',
      to: {
        name: 'locations',
      },
    },
  },
};
